<template>
  <login-template :loading="loading">
    <span class="f4 text-primary lh-copy">
      Выполняется вход в систему...
    </span>
  </login-template>
</template>

<script>
import LoginTemplate from './LoginTemplate.vue'

export default {
  components: {
    LoginTemplate
  },
  props: ['sid', 'comeinRoute', 'fallbackRoute'],
  data: () => ({
    loading: false
  }),
  mounted () {
    this.loading = true
    // если кто-то заходит по сид, разлогиниваем текущего пользователя!
    // this.$store.dispatch('session/remove').finally(() => {
    this.$store.dispatch('session/createFromSid', +this.sid)
      .then(({ user, errors }) => {
        if (user) {
          this.$router.push(this.comeinRoute())
        } else {
          this.$router.push(this.fallbackRoute(errors))
        }
      })
      .catch((e) => {
        console.error(e)
      })
      .finally(() => {
        this.loading = false
      })
  // })
  }
}
</script>

<style lang="scss" scoped>
</style>
